import { Cell, Label, Pie, PieChart } from "recharts";

const CenterLabel = ({ viewBox, value = 0, title = "title" }) => {
  const { cx, cy } = viewBox;

  return (
    <>
      <text x={cx - 24} y={cy - 15}>
        <tspan
          fill="#000"
          dominantBaseline={"central"}
          fontSize={"24px"}
          fontFamily="Poppins, serif"
          fontWeight="600px"
        >
          {value}
        </tspan>
      </text>
      <text x={cx - 52} y={cy + 15}>
        <tspan
          fill="#7B8794"
          dominantBaseline={"central"}
          fontSize={"11px"}
          fontFamily="Poppins, serif"
          fontWeight="500px"
        >
          {title}
        </tspan>
      </text>
    </>
  );
};

const renderCustomizedLabel = (viewBox, values) => {
  const { index, x, y } = viewBox;
  if (!values[index]?.value) return <></>;

  return (
    <>
      <text
        x={x}
        y={y + 15}
        fill="#6B4750"
        textAnchor="middle"
        dominantBaseline={"central"}
        fontSize={"12px"}
        fontFamily="Poppins, serif"
      >
        {values[index]?.name}
      </text>
      <text
        x={x}
        y={y}
        fill="#6B4750"
        textAnchor="middle"
        dominantBaseline={"central"}
        fontSize={"10px"}
        fontFamily="Poppins, serif"
      >
        {values[index]?.value?.toLocaleString()}
      </text>
    </>
  );
};

const CustomPieChart = ({
  width = 500,
  height = 500,
  data,
  centerLabel,
  innerRadius = 0,
  customLabel = true,
}) => {
  data[0] = { ...data[0], fill: "rgba(107, 142, 118, 1)" };
  data[1] = { ...data[1], fill: "rgba(182, 215, 185, 1)" }; // Female color
  data[2] = { ...data[2], fill: "rgba(151, 183, 154, 1)" }; // Other color

  return (
    <PieChart width={width} height={height}>
      <Pie
        data={data}
        cx="50%"
        cy="50%"
        labelLine={false}
        label={
          customLabel ? (viewBox) => renderCustomizedLabel(viewBox, data) : null
        }
        outerRadius={100}
        innerRadius={innerRadius}
        fill="#6B4750"
        dataKey="value"
        strokeWidth={5}
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.fill} />
        ))}
        {/* <Label
            content={({ viewBox }) => (
              <CenterLabel
                viewBox={viewBox}
                value={data[0]?.value}
                title={data[0]?.name}
              />
            )}
            position="center"
          /> */}
       {Array.isArray(data) && data.length > 0 ? (
          <Label
            content={({ viewBox }) => {
              // Filter out zero values to avoid showing 'Other' when it's 0
              const filteredData = data.filter(d => d.value > 0);

              // Get the max value audience
              const topAudience = filteredData.reduce((max, curr) =>
                curr.value > max.value ? curr : max
              );

              return (
                <CenterLabel
                  viewBox={viewBox}
                  value={`${topAudience.value}%`}
                  title={`${topAudience.name} Audience`}
                />
              );
            }}
            position="center"
          />
        ) : (
          <></>
        )}
      </Pie>
    </PieChart>
  );
};

export default CustomPieChart;
